import { useGetMappingQuizQuery } from '../apis/mapping-quiz.api'
import { CurriculumMappingQuizQuestionResponseDto } from '../types/mapping-quiz.types'

const useGetMappingQuiz = ({
  countryCode,
  gradeLevel,
  subjectOrder,
  subjectLabel,
  version,
  reset = false,
  skip,
}: {
  countryCode: string
  gradeLevel: string
  subjectOrder: number
  subjectLabel: string
  version: string
  reset?: boolean
  skip?: boolean
}): { mappingQuizQuestion: CurriculumMappingQuizQuestionResponseDto | undefined; isLoading: boolean } => {
  // The v1 curriculum mapping quiz endpoint is no longer supported and errors when called
  // with version 'v1'. Every visitor of a v1 mapping-quiz URL is redirected to the v2 grade
  // overview (see useRedirectV2UserToGradeOverview), so skipping the request here has no
  // user-facing impact — it only avoids the guaranteed error.
  const isV1 = version === 'v1'

  const { data: mappingQuizQuestion, isLoading } = useGetMappingQuizQuery(
    {
      countryCode,
      gradeLevel,
      subjectOrder,
      curriculumSubject: subjectLabel,
      version,
      reset,
    },
    { skip: skip || isV1 },
  )

  return {
    mappingQuizQuestion,
    isLoading,
  }
}

export default useGetMappingQuiz
